/**
 * 题干 RichEditor 聚焦描边：iframe 模式操作 .tox-edit-area；inline 模式操作 .boss-rich-editor 外壳。
 * 使用 outline 而非 border，避免聚焦/失焦时边框占位变化导致布局抖动。
 * @param {{ toggleToolbar?: boolean }} [options] toggleToolbar 为 false 时不改工具栏显隐（问卷介绍 inline 等场景，避免 focus 后弹出固定工具条）。
 */
export function applyQuestionStemFocusBorder(containerEl, options = {}) {
    const { toggleToolbar = true } = options;
    if (!containerEl) {
        return;
    }
    const editArea = containerEl.querySelector('.tox-edit-area');
    const header = containerEl.querySelector('.tox-editor-header');
    if (editArea) {
        editArea.style.outline = '2px solid #1a73e8';
        editArea.style.outlineOffset = '-2px';
        if (header && toggleToolbar) {
            header.style.display = 'block';
        }
    } else {
        const shell = containerEl.querySelector('.boss-rich-editor');
        if (shell) {
            shell.style.outline = '2px solid #1a73e8';
            shell.style.outlineOffset = '2px';
        } else {
            containerEl.style.outline = '2px solid #1a73e8';
            containerEl.style.outlineOffset = '2px';
        }
    }
}

export function clearQuestionStemFocusBorder(containerEl, options = {}) {
    const { toggleToolbar = true } = options;
    if (!containerEl) {
        return;
    }
    const editArea = containerEl.querySelector('.tox-edit-area');
    const header = containerEl.querySelector('.tox-editor-header');
    if (editArea) {
        editArea.style.outline = 'none';
        editArea.style.outlineOffset = '';
        if (header && toggleToolbar) {
            header.style.display = 'none';
        }
    } else {
        const shell = containerEl.querySelector('.boss-rich-editor');
        if (shell) {
            shell.style.outline = 'none';
            shell.style.outlineOffset = '';
        } else {
            containerEl.style.outline = 'none';
            containerEl.style.outlineOffset = '';
        }
    }
}
